var RwAjaxVote = (function () {

  // funzione php: inc/riservata/vote/func-ajax-vote.php
  // La security è definita in inc/enqueue.php da rw_ajax_obj
  var vota = function (post_id, post_type, blog_id, vote_cat) {

    console.log('votazione in corso');

    $.ajax({
      url : rw_ajax_obj.ajax_url,
      type : 'post',
      data : {
        action : 'rw_ajax_vote',
        security : rw_ajax_obj.ajax_nonce,
        post_id : post_id,
        post_type : post_type,
        blog_id : blog_id,
        vote_cat : vote_cat
      },
      beforeSend: function() {
      },
      success : function( response ) {
        // response = $.parseJSON(response);
        // console.log(response)
      },
      error: function( jqXHR, textStatus, errorThrown ){
        console.log( 'Errore: ' + textStatus, errorThrown );
      },
      complete: function( jqXHR, textStatus ){
      }
    });

  };


  var start = function () {

    // console.log('ajax-vote started');
    // reset stato pulsante vote
    $('#start-vote i').removeClass('fas').addClass('fal');


    // ricavo array dati categorie di voto
    const votecats = JSON.parse( atob( document.getElementById('griglia').dataset.voteCats ) );


    // al click sull'icona di voto esplodo lista categorie
    $('.vote-button i').click(function(e){
      e.preventDefault();

      $(this).parent().addClass('voting').append('<ul id="votinglist" class="list-group"></ul>');

      votecats.forEach((cat) => {
        $('#votinglist').append('<li class="list-group-item list-group-item-action" data-cat-id="'+ cat.id +'" data-slug="'+ cat.slug +'">'+ cat.name +'</li>')
      });
    });


    $('.vote-button').on('click', '#votinglist li', function(e) {
      e.preventDefault();

        var post_id = $(this).closest('.vote-button').data('id');
        var post_type = $(this).closest('.vote-button').data('type');
        var blog_id = $(this).closest('.vote-button').data('blog');
        var vote_cat = $(this).data('cat-id');
        console.log('post_id: ' + post_id + ' post_type: ' + post_type + ' blog_id: ' + blog_id + ' vote_cat: ' + vote_cat);

        // rimuovi ul
        $(this).parent().remove();

        vota(post_id, post_type, blog_id, vote_cat);

        // toggle dell'icona cuore piena/vuota
        var vote_btn = '.vote-' + post_type + '-' + post_id + ' i';
        if($(vote_btn).hasClass('fal')){
          $(vote_btn).removeClass('fal').addClass('fas');
        } else {
          $(vote_btn).removeClass('fas').addClass('fal');
        }

        // solo un voto per categoria, rimuovo la classe di categoria votata dagli altri article
        $('#griglia article').removeClass('cv-' + vote_cat);

        // aggiungo la classe voted e categoria votata sia a griglia che a lista in modo da poterla filtrare senza ricaricare
        var $article = $('.' + post_type + '-' + post_id);
        $article.toggleClass('voted').addClass('cv-' + vote_cat);

    });



  };


  return {
    start : start
  }


})();
